import { render, staticRenderFns } from "./systemroleslist.vue?vue&type=template&id=2be208c2&scoped=true"
import script from "./systemroleslist.vue?vue&type=script&lang=js"
export * from "./systemroleslist.vue?vue&type=script&lang=js"
import style0 from "./systemroleslist.vue?vue&type=style&index=0&id=2be208c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be208c2",
  null
  
)

export default component.exports